<template>
    <div class="map-wrapper" :class="userDevice">
        <template v-if="userDevice === 'pc'">
            <div class="tag-wrapper">
                <div
                    v-for="(tag, i) in tags"
                    :key="i"
                    class="tag"
                    v-text="`#${tag}`"
                />
            </div>
            <div class="btn-wrapper">
                <div
                    v-for="(btn, i) in btns"
                    :key="i"
                    class="btn"
                    :class="{ big: btn.big, clear: btn.claer, doing: btn.doing }"
                    :style="{ top: `${btn.top}px`, left: `${btn.left}px` }"
                    v-html="btn.claer ? i + 1 : ''"
                    @click="toMission(btn.cat, btn.claer || btn.doing)"
                />
            </div>
            <div class="desc-wrapper">
                <div
                    class="desc"
                    style="top: 840px; left: 300px"
                >
                    <div class="title">펭수 움직이기</div>
                    <div class="text">
                        "도와주떼요, 떤배님"<br>
                        게임의 기본은 캐릭터를 움직이는 일이에요.<br>
                        펭수가 장애물을 피할 수 있도록 만들어봅시다.<br>
                    </div>
                </div>
                <div
                    class="desc"
                    style="top: 1280px; left: 660px"
                >
                    <div class="title">게임 점수 올리기</div>
                    <div class="text">
                        "매니저, 참치가 먹고 싶습니다!"<br>
                        펭수가 좋아하는 음식은 무엇인가요?<br>
                        참치를 먹고 게임 점수를 올려봅시다.<br>
                    </div>
                </div>
                <div
                    class="desc"
                    style="top: 1570px; left: 280px"
                >
                    <div class="title">게임 속 환경 바꾸기</div>
                    <div class="text">
                        "남극은 춥다, 다른 곳도 가고 싶어"<br>
                        게임 속 배경이 항상 남극이라 불만인 펭수.<br>
                        펭수를 위해 게임 속 환경을 다양하게 바꿔봅시다.<br>
                    </div>
                </div>
                <div
                    class="desc"
                    style="top: 2010px; left: 640px"
                >
                    <div class="title">특수 기능 추가하기</div>
                    <div class="text">
                        "나도 마법을 쓰고 싶어, 펭펭!"<br>
                        달리기 게임을 더욱 재밌게 만들고 싶나요?<br>
                        펭수에게 체력과 투명 기능을 만들어봅시다.<br>
                    </div>
                </div>
                <div
                    class="desc"
                    style="top: 2160px; left: 240px"
                >
                    <div class="title">나만의 게임 만들기</div>
                    <div class="text">
                        "신이나 신이나 엣헴 엣헴 신이나"<br>
                        친구들이 원하는 게임을 자유롭게!<br>
                    </div>
                </div>
                <div
                    class="desc"
                    style="top: 2430px; left: 240px"
                >
                    <div class="title">게임 최고점 달성하기</div>
                    <div class="text">
                        "펭수는 끝까지 달릴 수 있습니다."<br>
                        최고 점수를 얻어보세요!<br>
                    </div>
                </div>
                <button
                    class="certi"
                    :class="{ active: isCleared }"
                    @click="isShowModal3 = isCleared"
                >
                    인증서 받기
                </button>
            </div>


            <template v-if="isShowModal">
                <div class="modal-bg" />
                <modal @close="isShowModal = false" />
            </template>
            <template v-if="isShowModal2">
                <div class="modal-bg" />
                <modal2 @close="isShowModal2 = false" />
            </template>
            <template v-if="isShowModal5">
                <div class="modal-bg" />
                <modal5 />
            </template>

            <modal3 v-if="isShowModal3" @close="isShowModal3 = false" />

            <map-info-input-template
                v-if="isNonUserInfo"
                @saveUser="isNonUserInfo = false; isLoading = true"
                :userDevice="userDevice"
                :courseCat="courseCat"
                is-trial
            />

            <img class="logo" src="../../assets/images/runner/logo.png">
        </template>
        <template v-else>
            <img src="../../assets/images/map/mobile_bg_peng.png" class="mobile-bg" @click="isShowModal4 = true">
            <modal4 :user-device="userDevice" v-if="isShowModal4" @close="isShowModal4 = false" />
        </template>
    </div>
</template>

<script>
import mobileDetect from 'mobile-detect'
import axios from 'axios';

import Modal from './Modal';
import Modal2 from './Modal2';
import Modal3 from './MapPartialCertificate';
import Modal4 from './Modal4';
import Modal5 from './Modal5';
import mapInfoInputTemplate from '../map/MapInfoInputPopup'

export default {
    components: {
        Modal,
        Modal2,
        Modal3,
        Modal4,
        Modal5,
        mapInfoInputTemplate
    },
    data() {
        return {
            tags: ['블록코딩 언어 활용', '코딩 기초 개념 습득', '미션별 교육 가이드 제공'],
            missions: [
                [
                    {
                        top: 0,
                        left: 403,
                        big: true,
                        doing: true,
                    },
                    {
                        top: 17,
                        left: 600
                    },
                    {
                        top: 17,
                        left: 746
                    },
                    {
                        top: 168,
                        left: 890
                    },
                    {
                        top: 310,
                        left: 890
                    }
                ],
                [
                    {
                        top: 433,
                        left: 764,
                        big: true
                    },
                    {
                        top: 450,
                        left: 601
                    },
                    {
                        top: 450,
                        left: 458
                    },
                    {
                        top: 600,
                        left: 312
                    },
                ],
                [
                    {
                        top: 725,
                        left: 410,
                        big: true
                    },
                    {
                        top: 742,
                        left: 602
                    },
                    {
                        top: 742,
                        left: 747
                    },
                    {
                        top: 880,
                        left: 890
                    },
                    {
                        top: 1025,
                        left: 890
                    },
                ],
                [
                    {
                        top: 1155,
                        left: 764,
                        big: true
                    },
                    {
                        top: 1172,
                        left: 601
                    },
                    {
                        top: 1172,
                        left: 456
                    },
                ],
                [
                    {
                        top: 1302,
                        left: 333,
                        big: true
                    },
                ],
                [
                    {
                        top: 1592,
                        left: 333,
                        big: true
                    }
                ]
            ],
            isShowModal: false,
            isShowModal2: false,
            isShowModal3: false,
            isShowModal4: false,
            isShowModal5: false,
            isLoading: false,
            userDevice: 'pc',
            courseCat: 'ESOF02',
            lbcookie: '',
            isNonUserInfo: false
        };
    },
    computed: {
        btns() {
            let prev;
            return this.missions.reduce((a, b, i1) => {
                b.forEach((e, i2) => {
                    e.cat = `ESOF02_1_${i1 + 1}_${i2 + 1}`;
                    e.doing = !e.claer && (!prev || (prev && prev.claer));
                    prev = e;
                });
                a.push(...b);
                return a;
            }, []);
        },
        isCleared() {
            return this.btns[this.btns.length - 1].claer;
        }
    },
    async mounted() {
        const MD = new mobileDetect(window.navigator.userAgent);
        if (MD.tablet() !== null) this.userDevice = 'tablet';
        else if (MD.mobile() !== null) this.userDevice = 'mobile';
        else {
            await this.init();
        }
    },
    methods: {
        async init() {
            const userInfo = JSON.parse(this.getCookie('runNonLoginUserInfo') || '{}');
            this.lbcookie = userInfo.lbparty;

            if (this.lbcookie) {
                this.isLoading = true;
                await this.setClearData();
            } else {
                this.isNonUserInfo = true;
            }
        },
        async setClearData() {
            const res = await axios.get(
                `${this.API_SERVER_URL}/manage/codmos/record/party/ESOF02/1/0/0?${this.randomId()}`,
                { headers: { lbcookie: this.lbcookie } }
            );

            if (
                res.data.code === '1000'
                && Array.isArray(res.data.docs)
            ) {
                res.data.docs.forEach(e => {
                    if (
                        e.isCleared
                        && this.missions[e.stageCat - 1]
                        && this.missions[e.stageCat - 1][e.missionCat - 1]
                    ) {
                        this.$set(this.missions[e.stageCat - 1][e.missionCat - 1], 'claer', true)
                    }
                });
            } else {
                document.cookie.split(';').forEach((c) => {
                    document.cookie = c.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
                });

                alert('유저 정보가 올바르지 않습니다.');

                location.reload();
            }
        },
        async toMission(cat, open) {
            if (!this.isLoading) return;

            if (open) {
                window.top.open(`/codmos/study/${cat}?type=trial`, '_blank');
            } else {
                this.isShowModal2 = true;
            }
        }
    }
}
</script>

<style>
    html, body {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
    }

    .map-wrapper > * {
        z-index: 99 !important;
    }
</style>

<style lang="scss" scoped>
    .map-wrapper {
        width: 1280px;
        &.pc {
            height: 2887px;
        }
        background: url('../../assets/images/runner/bg.png') no-repeat;
        margin: auto;
        position: relative;
        > * {
            z-index: 1;
        }
    }

    .tag-wrapper {
        background: #badce8;
        display: inline-block;
        font-family: 'AppleSDGothicNeoR00', sans-serif;
        font-size: 18px;
        letter-spacing: -.5px;
        color: #313B51;
        position: absolute;
        top: 310px;
        left: 355px;
        width: 623px;
        height: 53px;
        border-radius: 50px;
        line-height: 53px;
        font-weight: 500;

        .tag {
            display: inline-block;
            margin-right: 15px;
            &:last-child {
                margin-right: 0;
            }
        }
    }

    .btn-wrapper {
        position: relative;
        z-index: 2;
        top: 725px;
        left: 0;

        .btn {
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
            font-family: 'AppleSDGothicNeoH00';
            font-size: 24px;
            color: #53402A;
            background: url('../../assets/images/runner/btn_off.png') no-repeat;
            width: 80px;
            height: 60px;
            line-height: 45px;
            &.clear {
                background: url('../../assets/images/runner/btn.png') no-repeat;
            }
            &.big {
                background: url('../../assets/images/runner/btn_off_big.png') no-repeat;
                &.clear {
                    background: url('../../assets/images/runner/btn_big.png') no-repeat;
                }
                width: 113px;
                height: 91px;
                line-height: 60px;
            }
            &.doing {
                background: url('../../assets/images/runner/btn_doing.png') no-repeat;
                width: 105px;
                height: 133px;
                margin-top: -67px;
                &.big {
                    margin-top: -50px;
                }
            }
        }
    }

    .desc-wrapper {
        position: relative;
        top: 0;
        left: 0;
        .desc {
            position: absolute;
            top: 0;
            left: 0;
            min-width: 300px;
            .title {
                display: inline-block;
                margin: auto;
                background: #6479cd;
                width: 200px;
                height: 45px;
                font-family: 'AppleSDGothicNeoM00';
                color: #fff;
                font-size: 18px;
                border-radius: 50px;
                line-height: 40px;
            }
            .text {
                background: #fff;
                font-family: 'AppleSDGothicNeoL00';
                font-size: 15px;
                padding: 40px 15px 30px 15px;
                margin-top: -20px;
                border-radius: 20px;
                box-sizing: border-box;
                line-height: 20px;
            }
        }
    }

    .modal-bg {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .logo {
        position: absolute;
        bottom: 70px;
        left: 200px;
    }

    .certi {
        position: absolute;
        top: 2610px;
        left: 300px;
        width: 187px;
        height: 56px;
        padding: 0;
        outline: 0;
        border: 0;
        box-sizing: content-box;
        border-radius: 30px;
        font-size: 18px;
        font-family: AppleSDGothicNeoB00;
        background: #b2b9d8;
        color: #808080;
        border-bottom: 8px solid #808080;
        &.active {
            cursor: pointer;
            background: #6479cd;
            color: #fff;
            border-bottom: 8px solid #4d61b2;
        }
    }


    .mobile-bg {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 999;
    }
</style>



// WEBPACK FOOTER //
// src/components/runner/MapNonLogin.vue